import React from 'react'
import "./Imp.css";

const Imp = () => {
  return (
   <h5 className='astrict'>*</h5>
  )
}

export default Imp